import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { buildEnv } from './environments/build-env';
import { initMonitoring } from './app/core/services/monitoringService/monitoring';

initMonitoring(buildEnv);

// import * as smoothscroll from 'smoothscroll-polyfill';

// smoothscroll.polyfill();

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
